import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_CHECK, AUTH_ERROR } from 'react-admin';
import { configAPI } from './config'
import './myutils';
import YemotMFAHandler from './UnitsStatistics/MFAHandler';

const saveToken = (token) => {
    sessionStorage.setItem('units1', Math.floor(Math.random() * 10000) + 1);
    sessionStorage.setItem('units2', Math.floor(Math.random() * 10000) + 1);
    sessionStorage.setItem('units3', Math.floor(Math.random() * 10000) + 1);
    sessionStorage.setItem('B', token.encodeDecode());
}

export default async(type, params) => {
    if (type === AUTH_LOGIN) {
        const { username, password, ymapitoken } = params;

        if (ymapitoken) {
            saveToken(ymapitoken);
            const mfaHandler = new YemotMFAHandler(ymapitoken);
            const tryMfa = await mfaHandler.validOrPass()
            if (tryMfa.status !== true) {
                window.location = `${configAPI.api.prod}/../../mfa.php?mode=SSO&ymapitoken=${ymapitoken}&callback=${window.location.origin + window.location.pathname}&callback_remove_token=1`;
                throw new Error('מועבר לביצוע אימות דו-שלבי');
            }
            return;
        }

        const request = new Request(configAPI.api.prod + 'Login?username=' + username + '&password=' + password);
        const requestRes = await fetch(request);
        const response = await requestRes.json();

        if (response.status < 200 || response.status >= 300 ||
            response.responseStatus === 'FORBIDDEN' || response.responseStatus === 'ERROR' || response.responseStatus !== 'OK') {
            throw new Error(response.statusText);
        } else {
            saveToken(response.token);
            const mfaHandler = new YemotMFAHandler(response.token);
            const tryMfa = await mfaHandler.validOrPass()
            if (tryMfa.status !== true) {
                window.location = `${configAPI.api.prod}/../../mfa.php?mode=SSO&ymapitoken=${response.token}&callback=${window.location.origin + window.location.pathname}&callback_remove_token=1`;
                throw new Error('מועבר לביצוע אימות דו-שלבי');
            }
        }
    }
    if (type === AUTH_LOGOUT) {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('selectedFile');
        sessionStorage.removeItem('copiedFile');
        sessionStorage.removeItem('action');
        return Promise.resolve();
    }
    if (type === AUTH_ERROR) {
        const status = params.message.status;
        if (status === 401 || status === 403) {
            sessionStorage.removeItem('token');
            return Promise.reject();
        }
        return Promise.resolve();
    }
    if (type === AUTH_CHECK) {
        const request = new Request(configAPI.api.prod + 'GetSession?token=' + sessionStorage.B.encodeDecode())
        return fetch(request)
            .then(resp => { return resp.json(); })
            .then(response => {
                return (response.responseStatus === 'OK') ? Promise.resolve() : Promise.reject();
            });
    }

    return Promise.resolve();
}